module.exports = __webpack_public_path__ + "img/iphone8screenshot1.db599361.png";